import { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { authService } from '../../services/auth.service';
import styles from './VerifyEmail.module.css';

function VerifyEmail() {
    const { t } = useTranslation('auth');
    const { t: tValidation } = useTranslation('validation');
    const [searchParams] = useSearchParams();
    const [status, setStatus] = useState('loading');
    const [errorKey, setErrorKey] = useState(null);

    useEffect(() => {
        const token = searchParams.get('token');
        if (!token) {
            setErrorKey('invalid_or_expired_token');
            setStatus('error');
            return;
        }
        authService.verifyEmail(token)
            .then(() => setStatus('success'))
            .catch((err) => {
                const key = err?.payload?.error;
                setErrorKey(typeof key === 'string' ? key : 'invalid_or_expired_token');
                setStatus('error');
            });
    }, [searchParams]);

    return (
        <div className={styles.page}>
            <div className={styles.card}>
                <img
                    src={`${process.env.PUBLIC_URL}/assets/menu-logo-name-only.png`}
                    alt="Logo"
                    className={styles.logo}
                />

                {status === 'loading' && (
                    <p className={styles.message}>{t('verification.verifying')}</p>
                )}

                {status === 'success' && (
                    <>
                        <h2 className={styles.title}>{t('verification.verified_title')}</h2>
                        <p className={styles.message}>{t('verification.verified_message')}</p>
                        <Link to="/" className={styles.loginLink}>{t('verification.login')}</Link>
                    </>
                )}

                {status === 'error' && (
                    <>
                        <h2 className={`${styles.title} ${styles.errorTitle}`}>{t('verification.error_title')}</h2>
                        <p className={styles.errorMessage}>{tValidation(errorKey ?? 'invalid_or_expired_token')}</p>
                        <Link to="/" className={styles.loginLink}>{t('verification.login')}</Link>
                    </>
                )}
            </div>
        </div>
    );
}

export default VerifyEmail;
